module.exports = __webpack_public_path__ + "static/media/ramp-loading.87612d3a.svg";